import { render, staticRenderFns } from "./HomeCarusel.vue?vue&type=template&id=5432dd86&scoped=true&"
import script from "./HomeCarusel.vue?vue&type=script&lang=js&"
export * from "./HomeCarusel.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarusel.vue?vue&type=style&index=0&id=5432dd86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432dd86",
  null
  
)

export default component.exports